import React from 'react';
import { Column } from 'shared';

import { LayoutWrapper } from './Layout.styles';
import { LayoutProps } from './Layout.types';

export const Layout = ({ header, footer, children }: LayoutProps) => (
  <LayoutWrapper className="layout" id="layout">
    {header && (
      <Column flex="0 0 auto" flexGrow="0" className="layout__header">
        {header}
      </Column>
    )}

    <Column flex="1 0 auto" className="layout__content">
      {children}
    </Column>

    {footer && (
      <Column flex="0 0 auto" flexGrow="0" className="layout__footer">
        {footer}
      </Column>
    )}
  </LayoutWrapper>
);
